import { useSelector } from "react-redux";
import PageNotFound from "../pageNoFound";
import AllowedAccess from "../../Layout/AllowedAccess";
import ErrorBoundry from "../../Services/ErrorBoundry";
import { Route, Routes } from "react-router-dom";
import EventsList from "./EventsList";
import AddEvent from "./AddEvent";
import UpdateEvent from "./UpdateEvent";
import ViewEvent from "./ViewEvent";
import PastEventsList from "./PastEventsList";
import DutyChart from "./DutyChart";
import AddDivisionRegistrationEvent from "./AddDivisionRegistrationEvent";
import UpdateDivisionRegistrationEvent from "./UpdateDivisionRegistrationEvent";

const EventsRoutes = () => {
    const { userData } = useSelector((state) => state.user);
    return (
        <Routes>
            <Route
                index
                element={
                    <EventsList />
                }
            />
            <Route
                path="past"
                element={
                    <PastEventsList />
                }
            />
            <Route path="add" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin", "captain", "div_admin"]}
                allowedPermissions={["add_event"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<AddEvent />}
            />} />
            <Route path="add-division-registration" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<AddDivisionRegistrationEvent />}
            />} />
            <Route path="edit-division-registration" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<UpdateDivisionRegistrationEvent />}
            />} />
            <Route path="edit" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin", "captain", "div_admin"]}
                allowedPermissions={["edit_event"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<UpdateEvent />}
            />} />
            <Route path="duty-chart" element={<AllowedAccess
                role={userData.role_slug}
                allowedRoles={["super_admin", "org_admin", "captain", "div_admin"]}
                allowedPermissions={["edit_event"]}
                userPermissions={userData.caps_list}
                renderNoAccess={() => <ErrorBoundry />}
                children={<DutyChart />}
            />} />
            <Route path="view" element={<ViewEvent />} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
}

export default EventsRoutes;